import React from "react";
import CryptoJS from "crypto-js";

function BillProxy() {
  const key = "9p8r7o6x5y4321e0";

  const fullUrl = window.location.href;
  const tramaEncriptada = fullUrl.includes("tramaSAP=")
    ? fullUrl.split("tramaSAP=")[1]
    : "";

  const desencriptarTrama = (textoEncriptado, secretKey) => {
    try {
      if (!textoEncriptado) return "";

      const keyWords = CryptoJS.enc.Utf8.parse(secretKey);

      const decrypted = CryptoJS.AES.decrypt(textoEncriptado, keyWords, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });

      return decrypted.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.error("Error al desencriptar la trama:", error);
      return "No se pudo desencriptar la trama";
    }
  };

  const tramaDesencriptada = desencriptarTrama(tramaEncriptada, key);

  return (
    <div style={styles.container}>
      <h2>Consulta de Factura - Proxy</h2>

      <div style={styles.section}>
        <h3>Trama encriptada</h3>
        <div style={styles.box}>
          {tramaEncriptada || "No se encontró tramaSAP en la URL"}
        </div>
      </div>

      <div style={styles.section}>
        <h3>Trama desencriptada</h3>
        <div style={styles.box}>
          {tramaDesencriptada || "No se pudo desencriptar"}
        </div>
      </div>
    </div>
  );
}

const styles = {
  container: {
    padding: "24px",
    fontFamily: "Arial, sans-serif",
  },
  section: {
    marginTop: "20px",
  },
  box: {
    marginTop: "8px",
    padding: "16px",
    border: "1px solid #ccc",
    borderRadius: "8px",
    backgroundColor: "#f5f5f5",
    wordBreak: "break-all",
    whiteSpace: "pre-wrap",
  },
};

export default BillProxy;